const fonts = {
  small: '1.8.rem',
  normal: '2rem',
  medium: '2.2rem',
  big: '2.8rem',
  huge: '4.2rem',
};

export default fonts;
